import React from 'react';
import { Typography } from '@saucelabs/ds-typography';
import { Badge } from '@saucelabs/ds-badge';
import { records as appStorageRecords, constants as appStorageConstants } from '@saucelabs/sl-module-app-storage';

const {
  APP_STORAGE_KIND,
} = appStorageConstants;

type TableCellBuildProps = {
  group: appStorageRecords.AppStorageGroup
};

const TableCellBuild: React.FC<TableCellBuildProps> = ({ group }) => {
  const isIos = group.recent.kind === APP_STORAGE_KIND.IOS;
  const isSimulator = group.recent.isSimulatorBuild();

  return (
    <>
      <Typography
        data-qa="app-management-groups-table-cell-build-label"
      >
        {group.getMostRecentUploadBuild()}
      </Typography>
      {isIos && isSimulator && (
        <Badge
          color="green"
          data-qa="app-management-groups-table-cell-badge-simulator"
          emphasis="low"
        >
          Simulator
        </Badge>
      )}
      {isIos && !isSimulator && (
        <Badge
          color="blue"
          data-qa="app-management-groups-table-cell-badge-real-device"
          emphasis="low"
        >
          Real Device
        </Badge>
      )}
    </>
  );
};

export default TableCellBuild;
